import React, { useEffect, useState, useRef } from "react"
import { useHistory } from "react-router-dom"
import { UniqueID } from "../../../services/CommonFunction"
import { selectIcon, SVG } from "../../UI/selector"
import "./VideoUI.scss"
import CarouselHoc from "../../../hoc/CarouselHoc/CarouselHoc"
import { videoPreviewSubject } from "../../../services/subscriberService"

const VideoUI = ({
  index,
  name,
  activity_logo_thumb,
  first_name,
  tileSize,
  activity_id,
  playback_url,
  duration_in_minutes,
  isNew,
  showNewTag,
  showTrend,
}) => {
  const [playStatus, setPlayStatus] = useState(false)
  const elementID = UniqueID()
  const timer = useRef(null)
  const history = useHistory()
  useEffect(() => {
    if (playStatus) {
      timer.current = setTimeout(() => {
        videoPreviewSubject.next({ id: elementID, url: playback_url })
      }, 500)
    } else {
      clearTimeout(timer.current)
      videoPreviewSubject.next(null)

    }
    return () => clearTimeout(timer.current)
  }, [playStatus])

  const handleParentClick = () => {
    history.push(`/ClassInfo/${activity_id}`)
  }

  return (
    <div
      id="videoTile"
      className={
        (tileSize === "small"
          ? "SmallVideoTileContainer"
          : "VideoTileContainer") + (showTrend ? " trending" : "")
      }
      onMouseEnter={() => setPlayStatus(true)}
      onMouseLeave={() => setPlayStatus(false)}
    >

      {showTrend ? (
        <div className="trend-num">
          <SVG src={selectIcon("T" + (index + 1))} />
        </div>
      ) : null}
      <div className="spinner" preview={elementID}><SVG src={selectIcon("loadingSpinner")} /></div>
      <div className="VideoTileParent" onClick={handleParentClick}>
        <p className="videoTitle">{name}</p>
        <div className="videoCoachInfo">
          <p>With {first_name}</p>
          <p>
            <SVG src={selectIcon("clock")} /> {Math.round(duration_in_minutes)}{" "}
            Mins
          </p>
        </div>
        {playStatus ? null : (
          <img className="thumbnail" src={activity_logo_thumb} />
        )}

        <video
          id={elementID}
          className={`videoTag${playStatus ? "" : " opacity0"}`}
          poster={activity_logo_thumb}
        />
        <div className="linearGradient"></div>
      </div>
      {showNewTag /* || isNew */ ? <p className="newTag">NEW</p> : null}
    </div>
  )
}

const OndemandHocCarousel = CarouselHoc(VideoUI, false)
export { VideoUI, OndemandHocCarousel }
